import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer.jsx';
import { buildAuthorizeUrl } from '../lib/strava.js';

/**
 * Strava login entry point (page-stravalogin.php). The actual OAuth handling and
 * mapping live on /your-map; this page just offers the link, matching the
 * original centered "Click HERE to login to strava!" screen.
 */
export default function StravaLoginPage() {
  const authorizeUrl = useMemo(
    () => buildAuthorizeUrl(`${window.location.origin}/your-map`),
    [],
  );

  return (
    <>
      <div
        style={{
          display: 'flex',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div>
          Click{' '}
          <a href={authorizeUrl}>
            <u>HERE</u>
          </a>{' '}
          to login to strava! Or go straight to{' '}
          <Link to="/your-map">
            <u>your map</u>
          </Link>
          .
        </div>
      </div>
      <Footer />
    </>
  );
}
